/**
 * Android executor: applies JS `EnforcementPlan` via LockboxEnforcement native module.
 */

import {
  getEnforcementHealthNative,
  lockboxEnforcementSupported,
  startLockboxEnforcementNative,
  stopLockboxEnforcementNative,
  submitRestrictionIntentNative,
} from "../../platform/lockboxBridge.js";

/** @typedef {import('../domain/types.js').EnforcementPlan} EnforcementPlan */

/** @type {import('./enforcementAdapter.js').EnforcementAdapter} */
export const androidEnforcementAdapter = {
  async submitIntent(plan) {
    if (!lockboxEnforcementSupported()) {
      return { ok: true, skipped: "android_lockbox_module_missing" };
    }
    const health = await getEnforcementHealthNative();
    const mode = plan.enforcementMode || "monitor";

    const result = await submitRestrictionIntentNative(plan);
    if (!result?.ok) {
      return { ok: false, error: result?.error || "native_submit_failed" };
    }

    if (mode === "monitor") {
      await stopLockboxEnforcementNative();
      return { ok: true, revision: result.revision };
    }

    if (!health.usageStatsGranted) {
      return {
        ok: true,
        skipped: "usage_stats_required",
        revision: result.revision,
      };
    }

    if (mode === "strict" || mode === "soft") {
      if (!health.overlayGranted) {
        return {
          ok: true,
          skipped: "overlay_permission_recommended",
          revision: result.revision,
        };
      }
      await startLockboxEnforcementNative();
    }

    return { ok: true, revision: result.revision };
  },
};
